import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { phoneTest } from "@/utils/phoneValidation";
import { Spinner } from "@/components/ui/spinner";
import { useForm } from "react-hook-form";

import { PatientForm } from "./patient-form";
import { usePatient } from "../api/get-patient";
import { useUpdatePatient } from "../api/update-patient";

const schema = yup
    .object({
        firstName: yup.string().required("Please enter your first name"),
        lastName: yup.string().required("Please enter your last name"),
        dateOfBirth: yup.string().required("Please enter your date of birth"),
        email: yup
            .string()
            .required("Please enter your email address")
            .email("Enter an email like name@example.com"),
        phoneNumber: yup
            .string()
            .required("Please enter your phone number")
            .test(phoneTest("GB")),
        addressNumber: yup
            .string()
            .required("Please enter your address number/name"),
        addressLine1: yup
            .string()
            .required("Please enter the first line of your address"),
        addressTown: yup.string().required("Please enter the town you live in"),
        addressCounty: yup
            .string()
            .required("Please enter the county you live in"),
        addressPostalCode: yup
            .string()
            .required("Please enter the postcode you live in"),
    })
    .required();

export const PatientUpdate = () => {
    // Get user data from firebase and patient data from local db
    const { data: patient, isLoading } = usePatient();

    const methods = useForm({
        resolver: yupResolver(schema),
        values: patient,
    });

    // Submit
    const mutation = useUpdatePatient();

    const onSubmit = (data) => {
        mutation.mutate(data);
    };

    if (isLoading) {
        return (
            <div className="relative">
                <div className="absolute inset-0 z-10 py-10">
                    <div className="grid h-75 place-items-center">
                        <Spinner size="lg" />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <PatientForm
            methods={methods}
            patient={patient}
            isPending={mutation.isPending}
            onSubmit={onSubmit}
        />
    );
};
